import { doc, IDocConfigs } from '@/types/documentViewerTypes';
import { useState } from 'react';

const intialConfigs: IDocConfigs = {
	docs: [],
	initial: 0,
	footerProps: null,
	//@ts-expect-error -need to fix this interface
	activeDoc: null,
};

export default function useDocViewer() {
	const [docViewerData, setDocViewerData] = useState<IDocConfigs>(intialConfigs);

	const renderFooter = (footer: any) => {
		setDocViewerData((prevState: any) => ({ ...prevState, footer }));
	};

	const handleAddDocs = (docs: doc[]) => {
		setDocViewerData((prevState: any) => ({ ...prevState, docs }));
	};

	const handleAddDoc = (doc: doc) => {
		setDocViewerData((prevState: any) => ({
			...prevState,
			docs: [...prevState.docs, doc],
		}));
	};

	const updateDocConfigs = (configs: Partial<IDocConfigs>) => {
		setDocViewerData((prevState: any) => ({ ...prevState, ...configs }));
	};

	const updateFooterProps = (configs: any) => {
		updateDocConfigs({
			footerProps: { ...(docViewerData.footerProps || {}), ...configs },
		});
	};

	const resetDocConfigs = () => {
		setDocViewerData({ ...intialConfigs });
	};

	const moveNextDoc = () => {
		setDocViewerData(prevState => {
			const index = prevState.docs.findIndex(doc => doc === prevState.activeDoc);
			const nextIndex = index === -1 ? 0 : (index + 1) % prevState.docs.length;
			return {
				...prevState,
				activeDoc: prevState.docs[nextIndex],
			};
		});
	};

	const handleSetActiveDoc = (currentDoc: number) => {
		setDocViewerData((prevState: any) => ({ ...prevState, initial: currentDoc }));
	};

	const handleCloseDocViewer = () => {
		return resetDocConfigs();
	};

	const updateActiveDocData = (updatedDocData: Partial<doc>) => {
		setDocViewerData(prevState => {
			if (!prevState.activeDoc) return prevState;

			const updatedActiveDoc = { ...prevState.activeDoc, ...updatedDocData };

			const updatedDocs = prevState.docs.map(docItem =>
				docItem === prevState.activeDoc ? updatedActiveDoc : docItem,
			);

			return {
				...prevState,
				activeDoc: updatedActiveDoc,
				docs: updatedDocs,
			};
		});
	};

	const setActiveDoc = (doc: doc) =>
		setDocViewerData(prevState => ({ ...prevState, activeDoc: doc }));

	return {
		docViewerData,
		setActiveDoc,
		handleAddDocs,
		handleAddDoc,
		updateFooterProps,
		handleCloseDocViewer,
		moveNextDoc,
		renderFooter,
		handleSetActiveDoc,
		updateDocConfigs,
		resetDocConfigs,
		updateActiveDocData,
	};
}
